import React from 'react'
import { Container, FormLabel, Row, Image } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const DevelopmentsSearch1 = ({ image }: RealEstateDataPageComponentData) => {
  return (
    <Container
      fluid
      className="position-relative p-0 min-vh-100 justify-content-center align-items-start d-flex bg-primary"
    >
      <Image
        className="w-100"
        // objectFit="cover"
        alt="Este logo viene del mock"
        src={image}
      />
      <Row className="position-absolute top-0 start-0 w-100 h-100 mt-5">
        <FormLabel className="text-white text-center">
          Soy el componente DevelopmentsSearch1, el background viene del mock
        </FormLabel>
      </Row>
    </Container>
  )
}

export default DevelopmentsSearch1
